export const PRODUCT_DATABASE = [
  {
    id: 1,
    name: "Hydraulic Quick Coupler",
    category: "Coupler",
    imageUrl: "/images/Coupler.png",
    specs: {
      pressure: "350",
      flowRate: "120"
    }
  },
  {
    id: 2,
    name: "Hydraulic Breaker M1400",
    category: "Breaker",
    imageUrl: "/images/M1400(2).jpg",
    specs: {
      pressure: "315",
      flowRate: "85"
    }
  },
  {
    id: 3,
    name: "Hydraulic Breaker M750",
    category: "Breaker",
    imageUrl: "/images/HBM750.png",
    specs: {
      pressure: "315",
      flowRate: "85"
    }
  },
];

export const PRODUCT_SEARCH_FEED = [
  {
    name: "Hydraulic Quick Coupler",
    imageUrl: "/images/Coupler.png",
    pressure: "380"
  },
  {
    name: "Hydraulic Breaker M1400",
    imageUrl: "/images/M1400(2).jpg",
    pressure: "210"
  },
  {
    name: "Hydraulic Breaker M750",
    imageUrl: "/images/HBM750.png",
    pressure: "190"
  }
];

export const TECHNICAL_INVENTORY = {
  mainSpecs: {
    title: "TECHNICAL DETAIL",
    headers: ["MODEL", "UNIT", "BUSAN M530", "BUSAN M680", "BUSAN M750", "BUSAN M1000", "BUSAN M1350", "BUSAN M1400", "BUSAN M1550"],
    rows: [
      { label: "Operating", unit: "kg", values: ["180", "340", "480", "950", "1650", "2000", "2900"] },
      { label: "Required Oil Flow", unit: "L/Min", values: ["25-50", "36-60", "50-90", "80-120", "130-170", "150-190", "150-230"] },
      { label: "Working Pressure", unit: "Bar", values: ["90-120", "110-140", "120-170", "150-170", "160-185", "165-195", "170-200"] },
      { label: "Impact Rate", unit: "bpm", values: ["600-1100", "500-900", "400-800", "400-650", "400-650", "400-800", "400-800"] },
      { label: "Chisel Diameter", unit: "mm", values: ["53", "68", "75", "100", "135", "140", "155"] },
      { label: "Hose Diameter", unit: "inch", values: ["-", "1/2", "1/2", "3/4", "1", "1", "1"] },
      { label: "Carrier Weight", unit: "ton", values: ["2-5", "3-7", "6-9", "10-15", "18-25", "20-30", "27-36"] }
    ]
  },
  compatibility: {
    title: "SUITABLE BACKHOE LOADER & EXCAVATORS",
    tables: [
      {
        headers: ["MODEL", "BULL", "CASE", "MAHINDRA", "TEREX"],
        rows: [
          ["BUSAN M680", "HD 76", "770", "SX", "TLB 740S"]
        ]
      },
      {
        headers: ["MODEL", "HITACHI", "KOMATSU", "HYUNDAI", "VOLVO", "KOBELCO", "SANY", "JCB", "DOOSAN", "CAT"],
        rows: [
          ["BUSAN M680", "JD315V", "N/A", "N/A", "N/A", "N/A", "N/A", "3D, 3DX", "N/A", "N/A"],
          ["BUSAN M750", "EX 70", "PC 71", "R 80", "N/A", "N/A", "SY 80", "JS 81, 4DX,3DX", "DX 81", "424 B"],
          ["BUSAN M1000", "EX 110, EX 210, ZX 110", "PC 130", "R 110, R 140", "EC 140", "SK 140", "SY 155, SY 140", "JS 120, JS 135, JS 140", "DX 150", "N/A"],
          ["BUSAN M1350", "EX 200, EX 210, ZX 200, ZX 210", "PC 200, PC 210", "R 210, R 240", "EC 210, EC 240", "SK 140, SK 210", "SY 210, SY 220, SY 250, SY 240", "JS 200, JS 205, JS 210, JS 220", "DX 225", "320 D"],
          ["BUSAN M1400", "EX 200, EX 210, ZX 200, ZX 210", "PC 200, PC 210", "R 210, R 240", "EC 210, EC 240", "SK 200, SK 210", "SY 210, SY 220, SY 250, SY 240", "JS 200, JS 205, JS 210, JS 220", "DX 225", "320 D"]
        ]
      }
    ]
  }
};

export const sliderData = [
  {
    id: 1,
    title: "GAS PRESSURE LOW",
    subtitle: "TROUBLESHOOTING: 01",
    description: "Problem: Breaker power decreases / works slow. Solution: Open top plate, check R-bolt valve, and refill Nitrogen to 12 bar.",
    descriptionHindi: "समस्या: ब्रेकर की पावर कम होना। समाधान: टॉप प्लेट खोलें, गैस चार्जिंग वाल्व चेक करें और नाइट्रोजन गैस 12 bar तक भरें।",
    image: "/images/Gas.png",
  },
  {
    id: 2,
    title: "CHISEL DAMAGE",
    subtitle: "TROUBLESHOOTING: 02",
    description: "Problem: Chisel broken or damaged. Solution: Remove front head pin, extract damaged tool, insert new chisel and lock the pin properly.",
    descriptionHindi: "समस्या: चीज़ल टूट जाना। समाधान: फ्रंट हेड पिन निकालें, पुराना चीज़ल बाहर निकालें और नया चीज़ल डालकर लॉक करें।",
    image: "/images/chasel.png",
  },
  {
    id: 3,
    title: "OIL LEAKAGE",
    subtitle: "TROUBLESHOOTING: 03",
    description: "Problem: Oil leaking from breaker. Solution: Inspect the seal kit, replace damaged seals immediately, and tighten all loose bolts.",
    descriptionHindi: "समस्या: ऑयल लीक होना। समाधान: सील किट चेक करें, खराब सील को बदलें और लूज बोल्ट को टाइट करें।",
    image: "/images/leakage.png",
  },
  {
    id: 4,
    title: "LOW HITTING POWER",
    subtitle: "TROUBLESHOOTING: 04",
    description: "Problem: Inconsistent force. Solution: Check gas pressure, hydraulic oil flow levels, and ensure all hose connections are secure.",
    descriptionHindi: "समस्या: कम मार करना। समाधान: गैस प्रेशर, हाइड्रोलिक ऑयल फ्लो और होज कनेक्शन की जांच करें।",
    image: "/images/lowpressure.png",
  }
];